
import { updatePasssword } from "@/apis/user";
import { ElMessage } from "element-plus";
import { computed, defineComponent, onMounted, reactive, toRefs, watch } from 'vue'
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { UserActionTypes } from '@/store/modules/user/action-types'
import { chineseVerification } from '@/utils/validate'
import { momentStamp } from '@/utils/robot'
import i18n from "@/locales";
const _t = i18n.global.t;
import { getLanguage } from "@/utils/cookies";

import { useI18n } from 'vue-i18n'
import moment from "moment";

const store = useStore()
const router = useRouter()

export default defineComponent({
  name: 'headPortrait',
  components: {
  },
  emits: ['change', 'signOutLogin'],
  props: {

  },
  setup(props: any, { emit }: any) {
    const { t } = useI18n()
    const state = reactive({
      oldEyeFlag: true,
      newEyeFlag: true,
      enStyle: false,
      confirmNewEyeFlag: true,
      eyeSrcHide: require('../../assets/images/public/passWord-hide.png'),
      eyeSrcShow: require('../../assets/images/public/passWord-show.png'),
      btnSubmit: false,
      ruleForm: {
        oldPassWord: '',
        newPassword: '',
        confirmNewPassword: ''
      },
      rules: {
        oldPassWord: [{ required: true, message: t('navigationBar.pleaseEnterOriginalPsd'), trigger: 'blur' }, { min: 6, max: 20, message: _t('account.pleaseuserpasnumb'), trigger: "blur" }],
        newPassword: [{ required: true, message: t('navigationBar.pleaseNewpassword'), trigger: 'blur' }, { min: 6, max: 20, message: _t('account.pleaseuserpasnumb'), trigger: "blur" }],
        confirmNewPassword: [{ required: true, message: t('navigationBar.PleEntertheNewPsdAga'), trigger: 'blur' }, { min: 6, max: 20, message: _t('account.pleaseuserpasnumb'), trigger: "blur" },],
      },
      drawer: false,
      userInfo: '' as any,
      dialogVisible: false
    })

    const methods = reactive({
      eyeChange(num: number) {

        if (num == 1) {
          state.oldEyeFlag = !state.oldEyeFlag
        } else if (num == 2) {
          state.newEyeFlag = !state.newEyeFlag
        } else if (num == 3) {
          state.confirmNewEyeFlag = !state.confirmNewEyeFlag
        }

      },

      dialogClose() {
        state.btnSubmit = false
        state.ruleForm.oldPassWord = ''
        state.ruleForm.newPassword = ''
        state.ruleForm.confirmNewPassword = ''
        state.oldEyeFlag = true
        state.newEyeFlag = true
        state.confirmNewEyeFlag = true
      },
      submitForm(formEl: any) {

        if (state.ruleForm.newPassword == state.ruleForm.oldPassWord) {
          ElMessage.error(t('navigationBar.TheNewPasastheoldone'))
          return
        }
        else if (state.ruleForm.newPassword != state.ruleForm.confirmNewPassword) {
          ElMessage.error(t('navigationBar.Psdisinconsistentwith'))
          return
        }

        let params = {
          new_password: state.ruleForm.newPassword,
          old_password: state.ruleForm.oldPassWord
        }
        updatePasssword(params).then((res: any) => {
          if (res.code == '200') {
            ElMessage({
              message: t('navigationBar.modifySuccessfully'),
              type: 'success',
            })
            state.dialogVisible = false
            emit('signOutLogin', true)
          } else {
            if (res.code == '40004') {
              ElMessage.error(_t('login.confirmAndNewParrword'))
            } else if (res.code == '40006') {
              ElMessage.error(_t('login.oldPasswordError'))
            } else {
              ElMessage.error(`${res.msg}`)
            }
          }

        })
      },
      resetForm(formEl: any) {
        state.dialogVisible = false
        if (!formEl) return
        formEl.resetFields()
      },
      outLogin() {
        emit('signOutLogin')
        // state.dialogFlag = true
      }
    })

    onMounted(() => {
      // state.userInfo = localStorage.getItem('userInfo')
      // state.userInfo = JSON.parse(state.userInfo)
      state.userInfo = store.state.user.getacct
      let language = getLanguage()
      if(language == 'en'){
        state.enStyle = true
      }else {
        state.enStyle = false
      }
    })

    watch(() => ({ ...state.ruleForm }), (newValue, oldValue) => {
      if (newValue.oldPassWord) {
        state.ruleForm.oldPassWord = chineseVerification(newValue.oldPassWord)
      }
      if (newValue.newPassword) {
        state.ruleForm.newPassword = chineseVerification(newValue.newPassword)
      }
      if (newValue.confirmNewPassword) {
        state.ruleForm.confirmNewPassword = chineseVerification(newValue.confirmNewPassword)
      }
      if (newValue.oldPassWord.length >= 6 && newValue.newPassword.length >= 6 && newValue.confirmNewPassword.length >= 6) {
        state.btnSubmit = true
      } else {
        state.btnSubmit = false
      }
    })

    return {
      ...toRefs(state),
      ...toRefs(methods),
      moment,
      momentStamp
    }
  }
})

